<template>
  <div>
    <panel :title="title || 'Projects'" :footerShow="true">
      <div slot="headingElements" v-show="_can('createProject')">
        <a class="btn btn-success" @click="addItemClick()"><i class="icon-add"></i> <span class="text-semibold">Add project</span></a>
      </div>
      <div>
        <div class="tabbable" v-if="_is('agencyAdmin') || _is('superAdmin')">
          <!-- Admin view -->
          <ul class="nav nav-tabs nav-tabs-top">
            <li class="active"><a href="#top-tab0" @click="storeHash" data-toggle="tab">Active</a></li>
            <li><a href="#top-tab1" @click="storeHash" data-toggle="tab">Inactive</a></li>
          </ul>

          <div class="tab-content">
            <div id="top-tab0" class="tab-pane active">
              <project-list :table-only="false" :uncover="true" :active="true"></project-list>
            </div>
            <div id="top-tab1" class="tab-pane">
              <project-list :table-only="false" :uncover="true" :active="false"></project-list>
            </div>
          </div>
        </div>
        <project-list v-else :table-only="false" :uncover="true" :active="true"></project-list>
      </div>
    </panel>
  </div>
</template>

<script>

import ProjectService from '@/services/project.service'
import ProjectList from './_partial/List'
import Panel from '@/components/_partial/_atomic/panel'

export default {
  components: { ProjectList, Panel },
  name: 'ProjectIndex',

  props: {
    'tableOnly': {
      type: Boolean,
      default: false
    },
    'title': {
      type: String
    }
  },

  data () {
    return {
      id: null,
      itemTemplate: {
        showModal: false
      },
      mode: {
        hash: false
      },
      itemSelected: {},
      service: ProjectService
    }
  },

  beforeMount () {
  },

  mounted () {
  },

  updated () {
    if (this.$route.hash.match(/#top\-tab\d+/i)) {
      let refid = this.$route.hash.replace(/[#\-]/g, '')
      console.log(refid, this.$refs, this.$refs[refid])
      if (this.mode.hash !== false) {
        refid = this.mode.hash.replace(/[#\-]/g, '')
      }
      this.$refs[refid].click()
    }
  },

  methods: {
    storeHash (e) {
      this.mode.hash = e.target.hash
    },
    addItemClick () {
      this.$router.push('project/add')
}
  }
}
</script>
<style scoped>

</style>
